export const CATEGORY_CODE = {
  LOCAL_TRAVELLER: 'LOCAL_TRAVELLER',
}
export const RESIDENT_POSTFIX = '-R'
